import { useSelector } from 'react-redux';
import { checkModalSubscription } from '../../../helper';

export default (modal) => {
  const { config } = useSelector((state) => state.services);
  const access = config?.access;
  if (!access.add_subscription) {
    return false;
  }
  return checkModalSubscription(modal)
};
